export const IMG_LOGO = '//qnm.hunliji.com/o_1b6r3ao08dfc14us1l62oo01k7k7.png'

export const IMG_PRO = '//qnm.hunliji.com/o_1cf6ui87ar6qcvemd817ut14av10.png'
export const IMG_ZUNXIANG =
  '//qnm.hunliji.com/o_1dpus01v517ch6k11s855df1r36a.png'

export const IMG_PRO_FULL =
  '//qnm.hunliji.com/o_1cfmr6bb8kl619dr78711afrsa7.png'
export const IMG_ZUNXIANG_FULl =
  '//qnm.hunliji.com/o_1dpus01v51tqk1kho1a901nc9244b.png'

export const IMG_WARNING =
  '//qnm.hunliji.com/o_1cf77da2j1tdo1o671rajkp6189h.png'

export const IMG_ERROR = '//qnm.hunliji.com/o_1cf77bc2t1qk514t9nhc2q51cra7.png'

export const IMG_SUCCESS = '//qnm.hunliji.com/o_1cf77cotihc21i5c1h59qsb42c.png'

export const IMG_MERCHANT_APP =
  '//qnm.hunliji.com/o_1cf4deu271gps14rfhnm9u4g7.png'

export const CHAT_IMG = '//qnm.hunliji.com/o_1cdjtlfmk54builv9gvf07lm7.png'

export const EDIT_IMG = '//qnm.hunliji.com/o_1cdjtq54l4fj179dvqf2msan0c.png'

// 商家等级 0 普通 1铜牌 2银牌 3.金牌 4.钻石 '
export const IMG_GRADE_DEFAULT =
  '//qnm.hunliji.com/o_1cfuikenfqnlcq31frivhe33eb.png'
export const IMG_GRADE_BRONZE =
  '//qnm.hunliji.com/o_1cfuikenf1krjbuk1bf5eu91dske.png'
export const IMG_GRADE_SILVER =
  '//qnm.hunliji.com/o_1cfuikenftcr16tu6tb1idb1gatf.png'
export const IMG_GRADE_GOLD =
  '//qnm.hunliji.com/o_1cfuikenf1de1ee72t157n1ppec.png'
export const IMG_GRADE_DIAMOND =
  '//qnm.hunliji.com/o_1cfuikenfecp79112dp7f5pqpd.png'

// 保证金标志
export const IMG_BOND = '//qnm.hunliji.com/o_1cfui1tbs1gqe19boru11vfa1t67.png'

export const PLAY_IMG = '//qnm.hunliji.com/o_1ct7htl1r96k8qgghg18b21ahh9.png'
